import { fetcherBlob } from "../../../../utils/fetcher";
import { useContext, useMemo, useRef } from "react";
import useSWR from "swr";
import { Context } from "../../../../context";

const Index = () => {
  const linkRef = useRef<HTMLAnchorElement>(null);
  const linkRefEn = useRef<HTMLAnchorElement>(null);
  const [data] = useContext(Context);
  const { token } = data;
  const { data: upute } = useSWR(
    `${process.env.REACT_APP_API_URL}/operateri/upute-csr`,
    (url: string) =>
      fetcherBlob(url, { headers: { Authorization: `Bearer ${token}` } })
  );
  const url = useMemo(() => {
    if (!upute || linkRef.current === null) return "/";
    linkRef.current.download = "Upute za kreiranje CSRa";
    // @ts-ignore
    return window.URL.createObjectURL(
      new File([upute], "CSR", { type: upute.type })
    );
  }, [upute]);

  const urlEn = useMemo(() => {
    if (!upute || linkRefEn.current === null) return "/";
    linkRefEn.current.download = "CSR manual";
    // @ts-ignore
    return window.URL.createObjectURL(
      new File([upute], "CSR", { type: upute.type })
    );
  }, [upute]);
  return (
    <p>
      Ovdje možete preuzeti{" "}
      <a ref={linkRef} href={url}>
        Upute za kreiranje CSR-a.
      </a>
      (You can download{" "}
      <a ref={linkRefEn} href={urlEn}>
        Instructions for generating CSR here
      </a>
      )
    </p>
  );
};

export default Index;
